namespace app.support.websocket {
    'use strict';

    export class WebsocketService {
        
        private stomp = null;
        private debug: (...args: string[])=> any = null;

        /** ngInject **/
        constructor(private $q: ng.IQService, private $cookies: ng.cookies.ICookiesService,
                    private $rootScope: ng.IRootScopeService) {  }
    
        public setDebug(callback: (...args: string[])=> any): void {
            this.debug = callback
        }
    
        public connect(endpoint: string, headers?: Object, errorCallback?: Function): ng.IPromise<any> {
            headers = headers || {};
    
            let defer: ng.IDeferred<any> = this.$q.defer();
            let access_token = this.$cookies.get("access_token");
            //@ts-ignore
            this.stomp = Stomp.over(this.websocketFactory(`${endpoint}?access_token=${access_token}`, errorCallback));
            this.stomp.debug = this.debug;
            this.stomp.connect(headers, (frame: any) => {
                defer.resolve(frame);
            }, (error: any) => {
                defer.reject(error)
                if (angular.isFunction(errorCallback)) {
                    errorCallback(error);
                }
            });
    
            return defer.promise;
        }
    
        public disconnect(): ng.IPromise<any> {
            let defer = this.$q.defer();
            this.stomp.disconnect(defer.resolve);
            return defer.promise;
        }
    
        public subscribe(destination: string, callback?: Function, headers?: Object): Object {
            headers = headers || {};
            return this.stomp.subscribe(destination, (response: any) => {
                let payload = null;
                try {
                    payload = angular.fromJson(response.body);
                } catch(e) {
                    payload = response.body;
                } finally {
                    if (callback) {
                        callback(payload, response.headers, response);
                        this.$rootScope.$apply();
                    }
                }
            }, headers);
        }
        
        public on(destination: string, callback?: Function, headers?: Object): Object {
            return this.subscribe(destination, callback, headers);        
        }
    
        public unsubscribe(subscription: any): void {
            subscription.unsubscribe();
        }
        
        public off(subscription: any): void {
            this.unsubscribe(subscription);
        }
    
        public send(destination: string, body: any, headers: Object): ng.IPromise<any> {
            let defer = this.$q.defer()
            try {
                let json = angular.toJson(body);
                headers = headers || {};
                this.stomp.send(destination, headers, json);
                defer.resolve();
            } catch (error) {
                defer.reject(error);
            }
            return defer.promise;
        }
        
        private websocketFactory(endpoint: string, errorCallback: Function): Function {
            return () => {
                let sock = new WebSocket(endpoint);
                sock.onclose = () => {
                    if (angular.isFunction(errorCallback)) {
                        errorCallback(new Error('Connection broken'))
                    }
                };
                return sock;
            }
        }

    }

    angular.module('app.support.websocket', []).service('websocketService', WebsocketService);
}